/* Formula Finder - native Shopify version. Logic tested against all answer combinations. */
(function () {
  const root = document.querySelector('.ff');
  if (!root) return;
  const $ = (id) => document.getElementById(id);
  const readJSON = (id) => { try { return JSON.parse($(id).textContent); } catch (e) { console.error('Formula Finder data', id, e); return null; } };

  const ATTRS = readJSON('ff-attrs') || {};
  const LIVE = readJSON('ff-live') || [];
  const CFG = readJSON('ff-config') || {};
  const CATALOG = LIVE.filter((p) => ATTRS[p.h]).map((p) => Object.assign({}, p, ATTRS[p.h]));
  const STORE_KEY = 'ff-state-v1';

  const AGES = [
    { v: 3, range: '0–5', unit: 'months', stage: 'Stage Pre and 1' },
    { v: 7, range: '6–9', unit: 'months', stage: 'Stage 2' },
    { v: 10, range: '10–11', unit: 'months', stage: 'Stage 2 or 3' },
    { v: 15, range: '12–23', unit: 'months', stage: 'Stage 3 or 4' },
    { v: 30, range: '24–36', unit: 'months', stage: 'Stage 3 or 4' }
  ];
  const PRIO = {
    organic: 'EU organic certified',
    demeter: 'Demeter-certified ingredients',
    nopalm: 'No palm oil in the ingredient list',
    nostarch: 'No starch or maltodextrin in the ingredient list',
    probiotic: 'Contains the culture L. fermentum',
    algaedha: 'DHA from microalgae oil, no fish oil'
  };
  const PRIO_TEXT = {
    organic: 'EU organic seal on the can.',
    demeter: 'Ingredients certified to Demeter biodynamic standards.',
    nopalm: 'Recipes made without palm oil.',
    nostarch: 'Lactose as the carbohydrate, no added starch or maltodextrin.',
    probiotic: 'HiPP formulas with a lactic acid culture.',
    algaedha: 'DHA sourced from microalgae.'
  };
  const STEPS = [
    { id: 'age', q: 'How old is your little one?', hint: 'We match the stage to the age printed on each can. You can always change this later.', type: 'age', opts: AGES },
    { id: 'milk', q: "Cow's milk or goat's milk?", hint: "There's no wrong answer here. All three of our brands make both.", type: 'single', cols: 'two', opts: [
      { v: 'cow', icon: 'cow', t: "Cow's milk", d: 'The classic choice most families start with.' },
      { v: 'goat', icon: 'goat', t: "Goat's milk", d: "A popular alternative many families love. Not suitable for babies with a cow's milk protein allergy." },
      { v: 'any', icon: 'any', t: 'Show me both', d: "Not sure yet? We'll show you cow and goat side by side." }
    ] },
    { id: 'need', q: 'Does your baby need a little extra care?', hint: 'If feeding feels tricky, your pediatrician is the best person to help you choose.', type: 'single', opts: [
      { v: 'none', icon: 'none', t: 'All good, thank you', d: "We'll show you our everyday formulas." },
      { v: 'comfort', icon: 'comfort', t: 'Fussiness, gas or bloating', d: "We'll include HiPP Comfort, a food for special medical purposes." },
      { v: 'reflux', icon: 'reflux', t: 'Frequent spit-up', d: "We'll include HiPP Anti Reflux, a food for special medical purposes." },
      { v: 'ha', icon: 'ha', t: 'Allergies run in our family', d: "We'll include HA formulas with hydrolyzed milk protein. They're not meant for a diagnosed cow's milk protein allergy." }
    ] },
    { id: 'prio', q: 'What matters most to you?', hint: "Choose as many as you like, or skip. We'll put the best fits first.", type: 'multi', cols: 'two',
      opts: ['nopalm', 'nostarch', 'probiotic', 'algaedha'].map((v) => ({ v: v, t: PRIO[v], d: PRIO_TEXT[v], icon: v })) },
    { id: 'brand', q: 'Do you have a favorite brand?', hint: "Pick one and we'll show only that brand, as long as it fits your answers.", type: 'single', cols: 'two', opts: [
      { v: 'any', icon: 'anybrand', t: 'Happy with any', d: "We'll find the best match across all brands." },
      { v: 'HiPP', logo: 'HiPP', t: 'HiPP', d: 'Family-owned in Germany since 1899. Cow and goat, plus specialty and HA formulas.' },
      { v: 'Holle', logo: 'Holle', t: 'Holle', d: 'Swiss and family-run for over 90 years. Many recipes with Demeter-certified ingredients.' },
      { v: 'Kendamil', logo: 'Kendamil', t: 'Kendamil', d: 'A family-owned British brand. Cow and goat, all made without palm oil.' }
    ] }
  ];
  const LABELS = { age: 'Age', milk: 'Milk', need: 'Extra care', prio: 'Priorities', brand: 'Brand' };
  const NEEDTXT = {
    comfort: 'Comfort formula with hydrolyzed whey protein and reduced lactose',
    reflux: 'Anti-reflux formula thickened with locust bean gum',
    ha: 'HA formula with hydrolyzed milk protein'
  };


  // Line icons (styleguide: thin black outline, no emojis). 48px grid.
  const I = (d) => '<svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">' + d + '</svg>';
  const COW = '<path d="M16 15c0-4 16-4 16 0l1 13c0 3-3 5-9 5s-9-2-9-5z"/><path d="M16 15c-4-1-6-4-5-8M32 15c4-1 6-4 5-8"/><path d="M15.5 18c-4 0-7.5 1.5-9 4 3 1.5 6.5 1 9-1M32.5 18c4 0 7.5 1.5 9 4-3 1.5-6.5 1-9-1"/><ellipse cx="24" cy="32" rx="8" ry="5"/><circle cx="21" cy="32" r=".9" class="f"/><circle cx="27" cy="32" r=".9" class="f"/><circle cx="20" cy="22" r=".9" class="f"/><circle cx="28" cy="22" r=".9" class="f"/>';
  const GOAT = '<path d="M19 13c0-3 10-3 10 0l1 14c0 4-3 7-6 7s-6-3-6-7z"/><path d="M20 12c-2-5-6-7-10-6 3 1 5 3 6 6M28 12c2-5 6-7 10-6-3 1-5 3-6 6"/><path d="M18.5 17c-4 0-8 1.5-10 4 3 1.2 7 .8 10-1.5M29.5 17c4 0 8 1.5 10 4-3 1.2-7 .8-10-1.5"/><path d="M21.5 33.5 24 42l2.5-8.5"/><circle cx="21.5" cy="22" r=".9" class="f"/><circle cx="26.5" cy="22" r=".9" class="f"/><path d="M22.5 29.5h3"/>';
  const ICONS = {
    cow: I(COW),
    goat: I(GOAT),
    any: I('<g transform="translate(-2 6) scale(.62)">' + COW + '</g><g transform="translate(20 6) scale(.62)">' + GOAT + '</g>'),
    none: I('<circle cx="24" cy="24" r="15"/><path d="M18 27c3.5 4 8.5 4 12 0"/><circle cx="19" cy="20" r="1" class="f"/><circle cx="29" cy="20" r="1" class="f"/>'),
    comfort: I('<circle cx="24" cy="24" r="15"/><path d="M15 24c3-4 6-4 9 0s6 4 9 0"/><path d="M18 17c1.5-1.5 3-1.5 4.5 0M25.5 31c1.5 1.5 3 1.5 4.5 0"/>'),
    reflux: I('<path d="M24 8c6 8 10 13 10 19a10 10 0 0 1-20 0c0-6 4-11 10-19z"/><path d="M24 33v-10M20 26.5l4-4 4 4"/>'),
    ha: I('<path d="M24 7l14 5v10c0 9-6 15-14 19-8-4-14-10-14-19V12z"/><path d="M18 24l4 4 8-8"/>'),
    nopalm: I('<path d="M24 40V20"/><path d="M24 20c-3-5-8-6-12-4M24 20c3-5 8-6 12-4M24 20c-5-1-9 2-10 6M24 20c5-1 9 2 10 6M24 20c0-4 2-8 5-10"/><path d="M10 38 38 10"/>'),
    nostarch: I('<path d="M24 41V14"/><path d="M24 18c-4-1-6-4-6-8 4 1 6 4 6 8zM24 18c4-1 6-4 6-8-4 1-6 4-6 8zM24 26c-4-1-6-4-6-8 4 1 6 4 6 8zM24 26c4-1 6-4 6-8-4 1-6 4-6 8zM24 34c-4-1-6-4-6-8 4 1 6 4 6 8zM24 34c4-1 6-4 6-8-4 1-6 4-6 8z"/><path d="M10 38 38 10"/>'),
    probiotic: I('<rect x="9" y="14" width="18" height="8" rx="4" transform="rotate(-30 18 18)"/><rect x="22" y="26" width="18" height="8" rx="4" transform="rotate(20 31 30)"/><circle cx="14" cy="33" r="3"/><circle cx="34" cy="14" r="2.5"/>'),
    algaedha: I('<path d="M24 7c6 8 11 14 11 21a11 11 0 0 1-22 0c0-7 5-13 11-21z"/><path d="M24 38V26M24 30c-4 0-6-3-6-6 4 0 6 2 6 6zM24 27c4 0 6-3 6-6-4 0-6 2-6 6z"/>'),
    anybrand: I('<rect x="9" y="9" width="12" height="12" rx="3"/><rect x="27" y="9" width="12" height="12" rx="3"/><rect x="9" y="27" width="12" height="12" rx="3"/><rect x="27" y="27" width="12" height="12" rx="3"/>')
  };

  let s = { step: 0, a: { prio: [] }, done: false };
  const dl = (event, data) => { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, data || {})); };
  const esc = (str) => String(str == null ? '' : str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const save = () => { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {} };

  // Stage rule: per product line show the highest stage the baby has reached (labeled minimum age).
  // Stage 3 therefore stays visible after 12 months unless the line already has a Stage 4 for that age.
  function ageFit(age) {
    const best = {};
    CATALOG.forEach((p) => { if (p.min <= age) best[p.fam] = Math.max(best[p.fam] == null ? -1 : best[p.fam], p.min); });
    // availability is applied after the stage rule, so a sold-out Stage 3 never falls back to Stage 2
    return CATALOG.filter((p) => p.min <= age && p.min === best[p.fam] && p.available);
  }
  function filterSet(a, useBrand) {
    if (useBrand === undefined) useBrand = true;
    let l = a.age != null ? ageFit(a.age) : CATALOG.filter((p) => p.available);
    if (a.milk && a.milk !== 'any') l = l.filter((p) => p.milk === a.milk);
    if (a.need) l = a.need === 'none' ? l.filter((p) => !p.need) : l.filter((p) => p.need === a.need);
    if (useBrand && a.brand && a.brand !== 'any') l = l.filter((p) => p.brand === a.brand);
    return l;
  }

  function answerText(id) {
    const v = s.a[id]; const st = STEPS.find((x) => x.id === id);
    if (id === 'prio') { if (!s.a.prioSet) return null; return v.length ? v.length + ' chosen' : 'Skipped'; }
    if (v == null) return null;
    const o = st.opts.find((o) => o.v === v);
    if (!o) return null;
    return id === 'age' ? o.range + ' ' + o.unit : o.t;
  }

  function renderProfile() {
    $('ff-facts').innerHTML = STEPS.map((st) => {
      const t = answerText(st.id);
      return '<li class="' + (t ? '' : 'is-empty') + '"><span>' + LABELS[st.id] + '</span><span>' + esc(t || 'Not yet') + '</span></li>';
    }).join('');
    const set = poolFor(s.a);
    $('ff-num').textContent = set.length;
    $('ff-numlabel').textContent = s.a.age != null ? (set.length === 1 ? 'formula fits so far' : 'formulas fit so far') : 'formulas on our shelf';
    const mc = $('ff-mcount');
    if (mc) mc.innerHTML = '<strong>' + set.length + '</strong> ' + $('ff-numlabel').textContent;
  }

  function progress(i) {
    return '<div class="ff__progress"><span class="ff__progress-label">Question ' + (i + 1) + ' of ' + STEPS.length + '</span><div class="ff__bars">' +
      STEPS.map((_, j) => '<i class="' + (j <= i ? 'is-on' : '') + '"></i>').join('') + '</div></div><p class="ff__mcount" id="ff-mcount"></p>';
  }

  function renderStep() {
    const st = STEPS[s.step]; let body = '';
    if (st.type === 'age') {
      body = '<div class="ff__ages" role="group" aria-label="Age">' + st.opts.map((o) =>
        '<button type="button" class="ff__age" data-v="' + o.v + '" aria-pressed="' + (s.a.age === o.v) + '"><span><span class="ff__age-range">' + o.range + '</span><span class="ff__age-unit">' + o.unit + '</span></span><span class="ff__age-stage">' + o.stage + '</span></button>').join('') + '</div>';
    } else {
      const multi = st.type === 'multi';
      body = '<div class="ff__opts ' + (st.cols ? 'ff__opts--two ' : '') + (multi ? 'ff__opts--multi' : '') + '" role="group">' + st.opts.map((o) => {
        const on = multi ? s.a.prio.indexOf(o.v) > -1 : s.a[st.id] === o.v;
        const logo = o.logo && CFG.logos && CFG.logos[o.logo];
        const media = logo ? '<span class="ff__opt-logo"><img src="' + esc(logo) + '" alt="' + esc(o.t) + '" loading="lazy"></span>' : (o.icon && ICONS[o.icon] ? '<span class="ff__opt-icon">' + ICONS[o.icon] + '</span>' : '');
        const title = logo ? '<span class="visually-hidden">' + esc(o.t) + '</span>' : '<span class="ff__opt-title">' + esc(o.t) + '</span>';
        return '<button type="button" class="ff__opt' + (media ? ' ff__opt--media' : '') + (logo ? ' ff__opt--logo' : '') + '" data-v="' + o.v + '" aria-pressed="' + on + '"><span class="ff__box"></span>' + media + '<span class="ff__opt-body">' + title + '<span class="ff__opt-text">' + esc(o.d) + '</span></span></button>';
      }).join('') + '</div>';
    }
    const canNext = st.type === 'multi' ? true : s.a[st.id] != null;
    const last = s.step === STEPS.length - 1;
    $('ff-panel').innerHTML = '<div class="ff__step">' + progress(s.step) +
      '<h2 class="ff__q" id="ff-q" tabindex="-1">' + st.q + '</h2><p class="ff__hint">' + st.hint + '</p>' + body + '<p class="ff__note" id="ff-note" hidden></p></div>' +
      '<div class="ff__nav"><button type="button" class="ff__link" id="ff-back" ' + (s.step === 0 ? 'hidden' : '') + '>Back</button><span></span>' +
      '<button type="button" class="button" id="ff-next" ' + (canNext ? '' : 'disabled') + '>' + (last ? 'Show my matches' : (st.type === 'multi' && !s.a.prio.length ? 'Skip' : 'Continue')) + '</button></div>';
    wireStep(st); updateNote(st); renderProfile();
  }

  function updateNote(st) {
    const el = $('ff-note'); if (!el) return; let msg = '';
    if (st.id === 'need' && s.a.milk === 'goat' && s.a.need && s.a.need !== 'none')
      msg = "Just so you know: our comfort, anti-reflux and HA formulas are all made with cow's milk. We'll show you those, and your pediatrician can help you decide.";
    if (st.id === 'need' && s.a.need === 'ha' && s.a.age >= 10)
      msg = "Our HA formulas go up to stage 2, labeled from 6 months. Your pediatrician can tell you if that's still the right fit for your baby.";
    if (st.id === 'brand' && s.a.brand && s.a.brand !== 'any' && !filterSet(s.a).length)
      msg = s.a.brand + " doesn't have a formula that fits all your answers, so we'll show you the closest matches from our other brands.";
    el.textContent = msg; el.hidden = !msg;
  }

  function wireStep(st) {
    $('ff-panel').querySelectorAll('[data-v]').forEach((b) => b.addEventListener('click', () => {
      const v = st.type === 'age' ? +b.dataset.v : b.dataset.v;
      if (st.type === 'multi') { const i = s.a.prio.indexOf(v); i > -1 ? s.a.prio.splice(i, 1) : s.a.prio.push(v); }
      else s.a[st.id] = v;
      $('ff-panel').querySelectorAll('[data-v]').forEach((x) => x.setAttribute('aria-pressed', st.type === 'multi' ? s.a.prio.indexOf(x.dataset.v) > -1 : String(x.dataset.v) === String(s.a[st.id])));
      const nx = $('ff-next'); nx.disabled = false;
      if (st.type === 'multi') nx.textContent = s.a.prio.length ? 'Continue' : 'Skip';
      updateNote(st); renderProfile(); save();
      dl('formula_finder_answer', { ff_question: st.id, ff_answer: st.type === 'multi' ? s.a.prio.join('|') : v });
      // single answers move on by themselves; a short pause shows the selection (and any note) first
      if (st.type !== 'multi' && !advancing) {
        advancing = true;
        const hasNote = !$('ff-note').hidden;
        setTimeout(goNext, hasNote ? 1400 : 260);
      }
    }));
    let advancing = false;
    function goNext() {
      if (st.type === 'multi') s.a.prioSet = true;
      dl('formula_finder_step', { ff_step: s.step + 1, ff_question: st.id });
      if (s.step < STEPS.length - 1) { s.step++; renderStep(); focusQ(); } else { s.done = true; renderResults(); }
      save();
    }
    $('ff-next').addEventListener('click', () => { if (!advancing) { advancing = true; goNext(); } });
    const bk = $('ff-back'); if (bk) bk.addEventListener('click', () => { s.step--; renderStep(); focusQ(); save(); });
  }
  function focusQ() {
    const h = $('ff-q'); if (h) h.focus({ preventScroll: true });
    if (window.innerWidth < 990) {
      const header = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
      const offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const top = $('ff-panel').getBoundingClientRect().top + window.scrollY - offset - 12;
      if (Math.abs(window.scrollY - top) > 8) window.scrollTo({ top: top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  // Same fallbacks as the results: other brands if the chosen brand has nothing, cow's milk specialty formulas for goat + need
  function poolFor(a, notes) {
    notes = notes || [];
    let pool = filterSet(a);
    if (!pool.length && a.brand && a.brand !== 'any') { pool = filterSet(a, false); notes.push(a.brand + " doesn't have a formula that fits all your answers, so we picked the closest matches from our other brands."); }
    if (!pool.length && a.need && a.need !== 'none' && a.age != null) {
      pool = ageFit(a.age).filter((p) => p.need === a.need);
      if (a.milk === 'goat') notes.push("Our specialty formulas are all made with cow's milk, so that's what you'll see here.");
    }
    return pool;
  }
  function computeMatches() {
    const a = s.a; const notes = [];
    const pool = poolFor(a, notes);
    if (a.need === 'ha' && a.age >= 10) notes.push("Our HA formulas go up to stage 2, labeled from 6 months. Your pediatrician can tell you if that's still the right fit.");
    if (pool.some((p) => p.fsmp)) notes.push("This is a food for special medical purposes, so please use it with your pediatrician's guidance.");
    const scored = pool.map((p) => {
      let sc = 0; a.prio.forEach((t) => { if (p.f[t]) sc += 1; });
      return Object.assign({}, p, { sc: sc });
    }).sort((x, y) => y.sc - x.sc || x.rank - y.rank);
    const out = []; const anyBrand = !a.brand || a.brand === 'any';
    for (const p of scored) {
      if (out.length === 3) break;
      if (anyBrand && out.some((o) => o.brand === p.brand) && scored.some((q) => out.indexOf(q) < 0 && q.sc === p.sc && !out.some((o) => o.brand === q.brand))) continue;
      out.push(p);
    }
    for (const p of scored) { if (out.length === 3) break; if (out.indexOf(p) < 0) out.push(p); }
    return { list: out, notes: notes };
  }

  function stageText(p) {
    if (p.stage === 'all') return 'Labeled from birth, for all stages';
    const from = p.min === 0 ? 'from birth' : 'from ' + (p.min >= 24 ? '2 years' : p.min === 12 ? '12 months' : p.min + ' months');
    return 'Stage ' + p.stage + ', labeled ' + from;
  }
  function reasons(p) {
    const a = s.a; const r = [stageText(p), p.milk === 'goat' ? "Goat's milk based" : "Cow's milk based"];
    if (p.need) r.push(NEEDTXT[p.need]);
    const picked = a.prio.filter((t) => p.f[t]);
    const shown = picked.length ? picked : ['organic', 'demeter', 'nopalm', 'nostarch'].filter((t) => p.f[t]).slice(0, 2);
    shown.forEach((t) => r.push(PRIO[t]));
    if (a.brand && a.brand !== 'any' && p.brand === a.brand) r.push('Your preferred brand, ' + p.brand);
    return r;
  }
  const MISS = { nopalm: 'free of palm oil', nostarch: 'free of starch and maltodextrin', probiotic: 'made with L. fermentum', algaedha: 'made with DHA from microalgae', organic: 'EU organic certified', demeter: 'Demeter certified' };
  function missing(p, short) { return s.a.prio.filter((t) => !p.f[t]).map((t) => short ? MISS[t] : PRIO[t]); }
  function altText(p) {
    const picked = s.a.prio.filter((t) => p.f[t]).map((t) => PRIO[t]);
    const parts = [stageText(p)];
    if (p.need) parts.push(NEEDTXT[p.need]);
    if (s.a.prio.length) parts.push.apply(parts, picked.slice(0, 2)); else parts.push(reasons(p)[2] || (p.milk === 'goat' ? "Goat's milk based" : "Cow's milk based"));
    let txt = parts.filter(Boolean).join('. ') + '.';
    const miss = missing(p);
    if (miss.length && s.a.prio.length) txt += ' Not ' + missing(p, true).join(' and ') + '.';
    return txt;
  }

  function tagsFor(list) {
    const t = ['formula-finder', 'ff-age-' + s.a.age + 'm', 'ff-milk-' + s.a.milk, 'ff-need-' + s.a.need, 'ff-brand-' + String(s.a.brand).toLowerCase()];
    s.a.prio.forEach((p) => t.push('ff-prio-' + p));
    if (list[0]) t.push('ff-rec-' + list[0].h);
    return t.join(', ');
  }

  function renderResults(posted) {
    const res = computeMatches(); const list = res.list; const top = list[0]; const alts = list.slice(1);
    if (!posted) dl('formula_finder_complete', { ff_recommendation: top ? top.h : 'none', ff_answers: JSON.stringify(s.a) });
    const miss = top ? missing(top) : [];
    let html = '<div class="ff__step"><h2 class="ff__q" id="ff-q" tabindex="-1">Here are our picks for your little one</h2><p class="ff__hint" style="margin-bottom:0">Based on your answers and what is printed on each can. Tap a formula to see the ingredients and how to prepare it.</p>';
    if (res.notes.length) html += '<div class="ff__note ff__note--result">' + res.notes.map((n) => '<p>' + esc(n) + '</p>').join('') + '</div>';
    if (top) {
      html += '<article class="ff__top"><a class="ff__top-pic" href="' + esc(top.url) + '" data-rec="' + esc(top.h) + '" aria-label="View ' + esc(top.t) + '">' + (top.img ? '<img src="' + esc(top.img) + '" alt="' + esc(top.alt) + '" width="240" height="240">' : '') + '</a><div>' +
        '<p class="ff__kicker ff__kicker--result">Our top pick for you</p><h3 class="ff__top-name">' + esc(top.t) + '</h3><p class="ff__price">' + esc(top.price) + '</p>' +
        '<ul class="ff__why">' + reasons(top).map((x) => '<li>' + esc(x) + '</li>').join('') + '</ul>' +
        (miss.length ? '<p class="ff__miss">Good to know: this one is not ' + esc(missing(top, true).join(' and ')) + '.</p>' : '') +
        '<div class="ff__actions"><button type="button" class="button" data-add="' + top.vid + '" data-h="' + esc(top.h) + '">Add to cart</button>' +
        '<a class="ff__link" href="' + esc(top.url) + '" data-rec="' + esc(top.h) + '">See details</a><span class="ff__status" id="ff-status" role="status"></span></div></div></article>';
    }
    if (alts.length) {
      html += '<div class="ff__alts">' + alts.map((p) => '<article class="ff__alt"><a class="ff__alt-pic" href="' + esc(p.url) + '" data-rec="' + esc(p.h) + '" aria-label="View ' + esc(p.t) + '">' + (p.thumb ? '<img src="' + esc(p.thumb) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</a><div>' +
        '<h4 class="ff__alt-name">' + esc(p.t) + '</h4><p class="ff__alt-text">' + esc(altText(p)) + ' ' + esc(p.price) + '</p><a href="' + esc(p.url) + '" data-rec="' + esc(p.h) + '">See details</a></div></article>').join('') + '</div>';
    }
    if (CFG.showLead) {
      html += posted ? '<p class="ff__saved">Thank you! Your matches are saved, and we will be in touch soon.</p>' : '<div id="ff-lead"></div>';
    }
    html += '<p class="ff__disclaimer">' + esc(CFG.disclaimer || '') + '</p></div>' +
      '<div class="ff__nav"><button type="button" class="ff__link" id="ff-edit">Change my answers</button><button type="button" class="ff__link" id="ff-restart">Start over</button></div>';
    $('ff-panel').innerHTML = html;

    if (CFG.showLead && !posted) {
      const tpl = $('ff-lead-template'); $('ff-lead').appendChild(tpl.content.cloneNode(true));
      const form = $('ff-lead').querySelector('form');
      $('ff-tags').value = tagsFor(list);
      form.addEventListener('submit', (e) => {
        const em = $('ff-email').value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { e.preventDefault(); $('ff-error').hidden = false; return; }
        s.posted = true; save();
        dl('formula_finder_lead', { ff_recommendation: top ? top.h : 'none' });
      });
    }
    $('ff-panel').querySelectorAll('[data-rec]').forEach((l) => l.addEventListener('click', () => dl('formula_finder_click', { ff_product: l.dataset.rec })));
    $('ff-panel').querySelectorAll('[data-add]').forEach((b) => b.addEventListener('click', () => addToCart(b)));
    $('ff-edit').addEventListener('click', () => { s.done = false; s.step = 0; renderStep(); focusQ(); save(); });
    $('ff-restart').addEventListener('click', () => { s = { step: 0, a: { prio: [] }, done: false }; renderStep(); focusQ(); save(); });
    renderProfile(); focusQ();
  }

  // Add to cart through the theme's cart drawer (same flow as product-form.js)
  function addToCart(btn) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const fd = new FormData();
    fd.append('id', btn.dataset.add); fd.append('quantity', '1');
    fd.append('properties[_source]', 'Formula Finder');
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map((x) => x.id));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading');
    fetch(CFG.cartAddUrl || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) { $('ff-status').textContent = res.description || 'Sorry, we could not add this formula. Please try again.'; return; }
        dl('formula_finder_add_to_cart', { ff_product: btn.dataset.h });
        fetch(CFG.cartUpdateUrl || '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { formula_finder: btn.dataset.h } }) }).catch(() => {});
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'formula-finder', productVariantId: btn.dataset.add });
        if (cart && cart.renderContents) { cart.classList.remove('is-empty'); cart.renderContents(res); }
        else window.location = CFG.cartUrl || '/cart';
      })
      .catch(() => { $('ff-status').textContent = 'Sorry, that did not work. Please try again.'; })
      .finally(() => { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); });
  }

  // Restore after the customer form reload (or a return visit in the same session)
  let restored = null;
  try { restored = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) {}
  const posted = !!document.querySelector('[data-ff-posted]');
  if (restored && restored.a) { s = restored; s.a.prio = (s.a.prio || []).filter((p) => ['nopalm', 'nostarch', 'probiotic', 'algaedha'].indexOf(p) > -1); }
  if (!CATALOG.length) { $('ff-panel').innerHTML = '<p>The finder is taking a short break. <a href="/collections/all">Browse all our formulas</a> in the meantime.</p>'; return; }
  if (s.done) renderResults(posted && s.posted); else renderStep();
})();
